



























































































































































































































































































































































































































































































































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import TenantPoolDetay from "@/components/tenantPool/TenantPoolDetay.vue";
import {
  EVENT_LEVEL_OPTIONS,
  TENANT_POOL_STATUSES,
  TenantPoolCircuit,
  TenantPoolEvent,
  TenantPoolRow,
  TenantPoolStatus,
  TenantPoolSummary,
  eventLevelMeta,
  formatDateTime,
  healthMeta,
  relativeTime,
  statusMeta
} from "@/entity/TenantPoolEntity";

/**
 * Yenileme gecikmesi basamakları (ms). İlk basamak normal aralık; sonrakiler
 * 429 / hata sonrası üstel geri çekilme. Tavan 60 sn.
 *
 * Okuma kovası 60 istek/dk. 8 sn'de summary + (olay sekmesi açıksa) events =
 * dakikada ~7,5–15 istek; iki sekme ~30, üç sekme ~45 — bu yüzden sekme
 * arka plandayken yoklama tamamen durur (visibilitychange).
 */
const GECIKME_BASAMAKLARI = [8000, 16000, 32000, 60000];

/** `Retry-After` saniye cinsinden gelirse üst sınır (ms) — sunucu saçmalarsa bekleme kilitlenmesin. */
const AZAMI_RETRY_AFTER = 300000;

/** API `trashed` parametresinin ekran karşılıkları — sözleşmede sabit üç değer. */
const IMHA_SECENEKLERI = [
  {text: "Hariç tut", value: ""},
  {text: "Dahil et", value: "with"},
  {text: "Yalnızca imha edilmişler", value: "only"}
];

@Component({
  components: {TenantPoolDetay}
})
export default class TenantHavuzu extends Vue {
  /* ---------------- durum ---------------- */
  ozet: TenantPoolSummary | null = null;
  ozetYukleniyor: boolean = false;
  ozetHatasi: string = "";

  sekme: number = 0;

  liste: TenantPoolRow[] = [];
  listeToplam: number = 0;
  listeYukleniyor: boolean = false;
  listeHatasi: string = "";
  // itemsPerPage tohumlanmalı: Vuetify'ın varsayılanı 10'dur ve footer'daki
  // seçenek listesinde bulunmadığı için ekranda 25 görünürken sunucuya 10 gider.
  listeSecenekleri: any = {itemsPerPage: 25};
  filtre: any = {status: [], error_code: "", q: "", trashed: ""};
  filtreHatalari: any = {};

  olaylar: TenantPoolEvent[] = [];
  olayToplam: number = 0;
  olayYukleniyor: boolean = false;
  olayHatasi: string = "";
  olaySecenekleri: any = {itemsPerPage: 25};
  olayFiltre: any = {level: "", event: "", error_code: "", tenant_pool_id: ""};
  olayFiltreHatalari: any = {};
  acikOlaylar: any[] = [];

  detayAcik: boolean = false;
  detayId: number | null = null;

  doldurDialog: boolean = false;
  bakimDialog: boolean = false;
  devreDialog: boolean = false;
  islemCalisiyor: boolean = false;
  bakimSkipPurge: boolean = false;
  bakimMax: string = "";

  otomatikYenile: boolean = true;
  baglantiSorunu: boolean = false;
  sonPollHatasi: string = "";
  /** 429 alındı: gösterge metni "bağlantı sorunu"ndan farklı olmalı. */
  hizSiniri: boolean = false;
  /** Artımlı turda gelen ve henüz kullanıcının görmediği olay sayısı. */
  yeniOlaySayisi: number = 0;

  private zamanlayici: any = null;
  /** GECIKME_BASAMAKLARI içindeki konum; 0 = normal aralık. */
  private geriCekilmeAdimi: number = 0;
  /** `Retry-After` başlığından gelen bir sonraki gecikme (ms); 0 = kullanılmıyor. */
  private retryAfterMs: number = 0;
  /** Olay akışının artımlı yenilenmesi için son görülen en yeni `created_at`. */
  private enYeniOlayZamani: string = "";
  private ozetGecikmeli: any = null;
  private gorunurlukDinleyicisi: any = null;
  private aramaGecikmesi: any = null;
  private olayAramaGecikmesi: any = null;
  /** Uçuşta bir istek varken bileşen yok edilirse yeni tur zamanlanmasın. */
  private yokEdildi: boolean = false;
  /**
   * Liste ve olay akışı birden çok yerden tetikleniyor (options watcher, filtre,
   * elle yenileme, pasif tur). Geç dönen eski bir yanıt yenisini ezmesin diye
   * her istek bir sıra numarası alır.
   */
  private listeSirasi: number = 0;
  private olaySirasi: number = 0;
  private ozetSirasi: number = 0;
  /**
   * Yoklama turunun kendi sırası: hızlı gizle/göster iki turu üst üste
   * başlatabilir. Geç dönen eski tur, yenisinin kurduğu zamanlayıcıyı
   * ezip gereksiz geri çekilme uygulamamalı.
   */
  private pollSirasi: number = 0;

  imhaSecenekleri = IMHA_SECENEKLERI;
  seviyeSecenekleri = EVENT_LEVEL_OPTIONS;

  /** Yalnızca API'nin kabul ettiği alanlar sıralanabilir; gerisi 422 doğurur. */
  listeBasliklari = [
    {text: "No", value: "id", width: 80},
    {text: "Durum", value: "status", sortable: false},
    {text: "Veritabanı", value: "db_name", sortable: false},
    {text: "Hata kodu", value: "error_code", sortable: false},
    {text: "Rezerve / Atanan", value: "kim", sortable: false},
    {text: "Oluşturulma", value: "created_at"},
    {text: "Üretim", value: "provisioned_at"},
    {text: "Hata", value: "failed_at"},
    {text: "Atanma", value: "assigned_at"}
  ];

  /** Olay akışı sunucuda sabit "yeniden eskiye" sıralıdır — sütun sıralaması yok. */
  olayBasliklari = [
    {text: "Zaman", value: "created_at", sortable: false, width: 170},
    {text: "Seviye", value: "level", sortable: false, width: 100},
    {text: "Olay", value: "event", sortable: false},
    {text: "Satır", value: "tenant_pool_id", sortable: false, width: 90},
    {text: "Hata kodu", value: "error_code", sortable: false},
    {text: "Mesaj", value: "message", sortable: false},
    {text: "", value: "data-table-expand"}
  ];

  /* ---------------- hesaplananlar ---------------- */

  /** Okuma uçları: ikinci faktör istemez, doğrudan API'ye gider. */
  get okumaBase(): string {
    return this.$store.state.icwApiUrl + "admin/tenant-pool/";
  }

  /**
   * Mutasyon uçları `admin/tenant-pool/panel/` yolundan geçer: panel sır
   * taşımaz, ikinci faktörün yerini sunucudaki gerçek oturum doğrulaması alır
   * (TenantPoolPanelGuard). Yol boşsa yazma düğmeleri hiç gösterilmez.
   */
  get mutasyonBase(): string {
    return this.$store.state.tenantPoolProxyUrl || "";
  }

  get yazmaAcik(): boolean {
    return this.ozet !== null && this.ozet.mutations_enabled && this.mutasyonBase !== "";
  }

  get saglik() {
    return healthMeta(this.ozet ? this.ozet.health.level : null);
  }

  get devre(): TenantPoolCircuit | null {
    return this.ozet ? this.ozet.circuit : null;
  }

  get devreAcik(): boolean {
    return this.devre !== null && this.devre.state === "open";
  }

  /**
   * `auto_reset_pending` yalnızca GET /circuit yanıtında gelir; summary'de
   * yoksa aynı kuralla hesaplanır (devre açık + parmak izi değişmiş).
   */
  get otomatikKapanacak(): boolean {
    const c = this.devre;
    if (c === null) {
      return false;
    }
    if (typeof c.auto_reset_pending === "boolean") {
      return c.auto_reset_pending;
    }
    return c.state === "open"
        && !!c.circuit_fingerprint
        && c.circuit_fingerprint !== c.current_fingerprint;
  }

  get streakYuzdesi(): number {
    const c = this.devre;
    if (c === null || !c.threshold) {
      return 0;
    }
    return Math.min(100, (c.failure_streak / c.threshold) * 100);
  }

  get dolulukYuzdesi(): number {
    const k = this.ozet ? this.ozet.capacity : null;
    if (k === null) {
      return 0;
    }
    if (typeof k.fill_ratio === "number") {
      return k.fill_ratio * 100;
    }
    return k.threshold > 0 ? Math.min(100, (k.ready / k.threshold) * 100) : 0;
  }

  get dolulukRengi(): string {
    // Havuz kapalıyken boş olması BEKLENEN durumdur, hata değil — kırmızı gösterme.
    if (this.ozet !== null && (!this.ozet.enabled || this.ozet.health.level === "disabled")) {
      return "grey";
    }
    const y = this.dolulukYuzdesi;
    if (y >= 100) {
      return "success";
    }
    return y > 0 ? "warning" : "error";
  }

  get sayaclar() {
    const sayilar: any = this.ozet ? this.ozet.counts : {};
    return TENANT_POOL_STATUSES.map(durum => ({
      durum,
      adet: sayilar[durum] === undefined ? 0 : sayilar[durum],
      meta: statusMeta(durum)
    }));
  }

  get durumSecenekleri() {
    return TENANT_POOL_STATUSES.map(durum => ({text: statusMeta(durum).text, value: durum}));
  }

  get listeFiltresiVarMi(): boolean {
    return (this.filtre.status && this.filtre.status.length > 0)
        || !!this.filtre.error_code
        || !!this.filtre.q
        || !!this.filtre.trashed;
  }

  /** Filtre yokken "filtreye uyan satır yok" demek yanıltıcı olur. */
  get listeBosMetni(): string {
    return this.listeFiltresiVarMi
        ? "Filtreye uyan havuz satırı yok."
        : "Havuzda henüz tenant yok.";
  }

  get olayFiltresiVarMi(): boolean {
    return !!this.olayFiltre.level
        || !!this.olayFiltre.event
        || !!this.olayFiltre.error_code
        || !!this.olayFiltre.tenant_pool_id;
  }

  get olayBosMetni(): string {
    return this.olayFiltresiVarMi
        ? "Filtreye uyan olay yok."
        : "Henüz olay kaydı yok.";
  }

  /** 429 ile ağ/sunucu hatasını ayır: operatör neyi beklediğini bilsin. */
  get yenilemeGostergesi(): string {
    if (!this.baglantiSorunu) {
      return "";
    }
    const saniye = Math.round(this.sonrakiGecikme() / 1000);
    return this.hizSiniri
        ? "Hız sınırı — yenileme duraklatıldı (" + saniye + " sn)"
        : "Bağlantı sorunu — yenileme yavaşlatıldı (" + saniye + " sn)";
  }

  /* ---------------- şablon yardımcıları ---------------- */

  durumMeta(durum: string) {
    return statusMeta(durum);
  }

  seviyeMeta(seviye: string) {
    return eventLevelMeta(seviye);
  }

  tarih(deger: string | null): string {
    return formatDateTime(deger);
  }

  gecenSure(deger: string | null): string {
    return relativeTime(deger);
  }

  baglamListesi(olay: TenantPoolEvent): { anahtar: string; deger: string }[] {
    const baglam = olay.context;
    if (!baglam || typeof baglam !== "object") {
      return [];
    }
    return Object.keys(baglam)
        .filter(k => baglam[k] !== null && baglam[k] !== "")
        .map(k => ({anahtar: k, deger: String(baglam[k])}));
  }

  /* ---------------- veri çekme ---------------- */

  async ozetGetir(): Promise<void> {
    const sira = ++this.ozetSirasi;
    try {
      const yanit = await this.$http.get(this.okumaBase + "summary");
      if (sira !== this.ozetSirasi) {
        return; // bayat yanıt: daha yenisi geldi
      }
      this.ozet = yanit.data.data;
      this.ozetHatasi = "";
    } catch (e) {
      if (sira !== this.ozetSirasi) {
        return; // bayat hata: taze başarılı durumu bozmasın
      }
      // Üst şerit hiç yüklenemediyse ekran sonsuza kadar iskelet göstermemeli;
      // "yükleniyor" ile "kalıcı arıza" ayırt edilebilir olmalı.
      this.ozetHatasi = this.hataMesaji(e);
      throw e;
    }
  }

  async listeGetir(): Promise<void> {
    const sira = ++this.listeSirasi;
    this.listeYukleniyor = true;
    this.listeHatasi = "";
    this.filtreHatalari = {};
    try {
      const s = this.listeSecenekleri;
      const params: any = {
        page: s.page || 1,
        per_page: s.itemsPerPage && s.itemsPerPage > 0 ? s.itemsPerPage : 25
      };
      if (s.sortBy && s.sortBy.length > 0) {
        params.sort = s.sortBy[0];
        params.dir = s.sortDesc && s.sortDesc[0] ? "desc" : "asc";
      }
      if (this.filtre.status && this.filtre.status.length > 0) {
        params.status = this.filtre.status.join(",");
      }
      if (this.filtre.error_code) {
        params.error_code = this.filtre.error_code;
      }
      if (this.filtre.q) {
        params.q = this.filtre.q;
      }
      if (this.filtre.trashed) {
        params.trashed = this.filtre.trashed;
      }

      const yanit = await this.$http.get(this.okumaBase + "tenants", {params});
      if (sira !== this.listeSirasi) {
        return; // daha yeni bir istek başlatılmış — bu yanıt bayat
      }
      this.liste = Array.isArray(yanit.data.data) ? yanit.data.data : [];
      this.listeToplam = yanit.data.pagination ? yanit.data.pagination.total : this.liste.length;
    } catch (e) {
      if (sira !== this.listeSirasi) {
        return;
      }
      this.liste = [];
      this.listeToplam = 0;
      this.filtreHatalari = this.alanHatalari(e);
      const ek = this.eslesmeyenHatalar(this.filtreHatalari, ["status", "error_code", "q", "trashed"]);
      this.listeHatasi = ek ? this.hataMesaji(e) + " — " + ek : this.hataMesaji(e);
    } finally {
      if (sira === this.listeSirasi) {
        this.listeYukleniyor = false;
      }
    }
  }

  /**
   * Olay akışı.
   *
   * `artimli=true` ise sayfa 1'i baştan çekmek yerine yalnızca son görülen
   * olaydan sonrası (`since`) istenir ve gelenler listenin BAŞINA eklenir.
   * Liste uzunluğu `per_page`'de sabit tutulur; böylece kullanıcı akışı
   * okurken tablo boyu değişip sayfa zıplamaz.
   *
   * Artımlı yalnızca 1. sayfada anlamlıdır — kullanıcı 2. sayfayı okuyorsa
   * araya satır girmesi konumunu kaydırırdı.
   */
  async olaylarGetir(artimli: boolean = false): Promise<void> {
    const s = this.olaySecenekleri;
    const sayfa = s.page || 1;
    const perPage = s.itemsPerPage && s.itemsPerPage > 0 ? s.itemsPerPage : 25;
    const artimliMi = artimli && sayfa === 1 && this.enYeniOlayZamani !== "";

    const sira = ++this.olaySirasi;
    // Artımlı turda tabloyu "yükleniyor" durumuna almıyoruz: okuma sırasında titremesin.
    if (!artimliMi) {
      this.olayYukleniyor = true;
      this.olayHatasi = "";
      this.olayFiltreHatalari = {};
    }
    try {
      const params: any = {page: sayfa, per_page: perPage};
      if (this.olayFiltre.level) {
        params.level = this.olayFiltre.level;
      }
      if (this.olayFiltre.event) {
        params.event = this.olayFiltre.event;
      }
      if (this.olayFiltre.error_code) {
        params.error_code = this.olayFiltre.error_code;
      }
      if (this.olayFiltre.tenant_pool_id) {
        params.tenant_pool_id = this.olayFiltre.tenant_pool_id;
      }
      if (artimliMi) {
        params.since = this.enYeniOlayZamani;
      }

      const yanit = await this.$http.get(this.okumaBase + "events", {params});
      if (sira !== this.olaySirasi) {
        return;
      }
      const gelen: TenantPoolEvent[] = Array.isArray(yanit.data.data) ? yanit.data.data : [];
      const sunucuToplam = yanit.data.pagination ? yanit.data.pagination.total : gelen.length;

      if (artimliMi && sunucuToplam > gelen.length) {
        // Yoklama aralığında bir sayfadan fazla olay yazılmış (ör. bakım turu
        // onlarca satırı imha etti). `since` sorgusu yalnızca en yeni sayfayı
        // döndürdüğü için araya giren olaylar bir daha hiç istenmezdi —
        // artımlıyı bırakıp tam yenilemeye düşüyoruz. İç çağrı kendi sıra
        // numarasını alır; bu turun finally'si artımlı olduğu için yükleme
        // bayrağına dokunmaz.
        return this.olaylarGetir(false);
      }

      if (artimliMi) {
        // `since` sunucuda `>=` ile karşılaştırılıyor: sınırdaki olay tekrar
        // gelir. id ile ayıklanmadan eklenirse akışta çift satır olur.
        const mevcut: any = {};
        this.olaylar.forEach(o => {
          mevcut[o.id] = true;
        });
        const yeniler = gelen.filter(o => !mevcut[o.id]);
        if (yeniler.length > 0) {
          this.olaylar = yeniler.concat(this.olaylar).slice(0, perPage);
          // `since`'li yanıtın pagination.total'ı yalnızca yeni olayları sayar,
          // akışın gerçek toplamı değildir — bu yüzden artırarak ilerliyoruz.
          this.olayToplam += yeniler.length;
          this.yeniOlaySayisi += yeniler.length;
        }
      } else {
        this.olaylar = gelen;
        this.olayToplam = yanit.data.pagination ? yanit.data.pagination.total : gelen.length;
        this.yeniOlaySayisi = 0;
      }

      this.enYeniOlayZamaniGuncelle();
    } catch (e) {
      if (sira !== this.olaySirasi) {
        return; // bayat istek: ne tabloyu boşalt ne geri çekilmeyi tetikle
      }
      if (!artimliMi) {
        this.olaylar = [];
        this.olayToplam = 0;
        this.olayFiltreHatalari = this.alanHatalari(e);
        const ek = this.eslesmeyenHatalar(
            this.olayFiltreHatalari,
            ["level", "event", "error_code", "tenant_pool_id"]
        );
        this.olayHatasi = ek ? this.hataMesaji(e) + " — " + ek : this.hataMesaji(e);
      }
      // Artımlı turda mevcut liste korunur ve alert basılmaz; hata yalnızca
      // üstteki göstergeye düşer (pasif turda ekranı hata yağmuruna çevirmeyiz).
      throw e; // poll döngüsü geri çekilmeyi uygulayabilsin
    } finally {
      if (sira === this.olaySirasi && !artimliMi) {
        this.olayYukleniyor = false;
      }
    }
  }

  /** Akış yeniden-eskiye sıralıdır: en yeni damga ilk elemandadır. */
  private enYeniOlayZamaniGuncelle() {
    if (this.olaylar.length > 0 && this.olaylar[0].created_at) {
      this.enYeniOlayZamani = this.olaylar[0].created_at;
    }
  }

  async tumunuYenile() {
    this.ozetYukleniyor = true;
    try {
      await this.ozetGetir();
      this.pollBasarili();
    } catch (e) {
      this.$toast.error(this.hataMesaji(e));
    } finally {
      this.ozetYukleniyor = false;
    }
    this.listeGetir();
    this.olaylarGetir().catch(() => undefined);
  }

  /* ---------------- otomatik yenileme ---------------- */

  /**
   * Liste bilerek yenilenmez: kullanıcı filtre değiştirdiğinde veya elle
   * istediğinde çekilir. Pasif turda yalnızca summary — ve olay sekmesi
   * açıksa events — sorgulanır.
   */
  private async pollTuru() {
    if (this.sekmeGizli()) {
      // Arka planda hiç istek atma ve yeniden zamanlama: görünür olunduğunda
      // visibilitychange zaten hemen bir tur başlatacak.
      return;
    }
    const sira = ++this.pollSirasi;
    try {
      await this.ozetGetir();
      if (this.sekme === 1) {
        await this.olaylarGetir(true); // artımlı: yalnızca yeni olaylar
      }
      if (sira !== this.pollSirasi) {
        return; // daha yeni bir tur var; zamanlamayı ona bırak
      }
      this.pollBasarili();
    } catch (e) {
      if (sira !== this.pollSirasi) {
        return; // bayat turun hatası taze durumu bozmasın
      }
      this.pollHatasi(e);
    }
    this.zamanla();
  }

  /** İlk başarılı istekte normale dön. */
  private pollBasarili() {
    this.baglantiSorunu = false;
    this.hizSiniri = false;
    this.geriCekilmeAdimi = 0;
    this.retryAfterMs = 0;
  }

  /** Pasif turda toast yağdırma: yalnızca üstteki gösterge işaretlenir. */
  private pollHatasi(e: any) {
    const durum = e && e.response ? e.response.status : 0;
    this.baglantiSorunu = true;
    this.sonPollHatasi = this.hataMesaji(e);

    if (durum === 429) {
      this.hizSiniri = true;
      this.retryAfterMs = this.retryAfterOku(e);
      this.geriCekilmeAdimi = Math.min(this.geriCekilmeAdimi + 1, GECIKME_BASAMAKLARI.length - 1);
      return;
    }

    // Ağ / 5xx: daha ölçülü geri çekil (32 sn'de dur), Retry-After geçerli değil.
    this.retryAfterMs = 0;
    this.geriCekilmeAdimi = Math.min(this.geriCekilmeAdimi + 1, 2);
  }

  /** Sunucu `Retry-After` verdiyse ona uy; HTTP-date biçimini yoksay. */
  private retryAfterOku(e: any): number {
    const basliklar = e && e.response ? e.response.headers : null;
    if (!basliklar) {
      return 0;
    }
    const ham = basliklar["retry-after"] || basliklar["Retry-After"];
    if (!ham) {
      return 0;
    }
    const saniye = parseInt(String(ham), 10);
    if (isNaN(saniye) || saniye <= 0) {
      return 0;
    }
    return Math.min(saniye * 1000, AZAMI_RETRY_AFTER);
  }

  private zamanla() {
    this.zamanlayiciTemizle();
    if (!this.otomatikYenile || this.yokEdildi || this.sekmeGizli()) {
      return;
    }
    this.zamanlayici = setTimeout(() => this.pollTuru(), this.sonrakiGecikme());
  }

  private sonrakiGecikme(): number {
    if (this.retryAfterMs > 0) {
      return this.retryAfterMs;
    }
    return GECIKME_BASAMAKLARI[Math.min(this.geriCekilmeAdimi, GECIKME_BASAMAKLARI.length - 1)];
  }

  private sekmeGizli(): boolean {
    return typeof document !== "undefined" && document.visibilityState === "hidden";
  }

  /**
   * Sekme arka plana geçince yoklama tamamen durur (okuma kovası 60/dk ve
   * panel birden fazla sekmede açık olabiliyor); öne gelince beklemeden bir
   * tur koşulur, böylece kullanıcı bayat veriye bakmaz.
   */
  private gorunurlukDegisti() {
    if (this.sekmeGizli()) {
      this.zamanlayiciTemizle();
      return;
    }
    if (this.otomatikYenile && !this.yokEdildi) {
      this.zamanlayiciTemizle();
      this.pollTuru();
    }
  }

  private zamanlayiciTemizle() {
    if (this.zamanlayici !== null) {
      clearTimeout(this.zamanlayici);
      this.zamanlayici = null;
    }
  }

  @Watch("otomatikYenile")
  onOtomatikYenile(acik: boolean) {
    if (acik) {
      this.pollBasarili();
      this.zamanla();
    } else {
      this.zamanlayiciTemizle();
    }
  }

  /**
   * Olay sekmesine geçilince akış tam olarak tazelenir: sekme kapalıyken
   * yoklama events'e hiç gitmediği için eldeki veri bayat olabilir.
   */
  @Watch("sekme")
  onSekmeDegisti(yeni: number) {
    if (yeni === 1) {
      this.yeniOlaySayisi = 0;
      this.olaylarGetir().catch(() => undefined);
    }
  }

  /* ---------------- filtreler ---------------- */

  @Watch("listeSecenekleri", {deep: true})
  onListeSecenekleri() {
    this.listeGetir();
  }

  @Watch("olaySecenekleri", {deep: true})
  onOlaySecenekleri() {
    this.olaylarGetir().catch(() => undefined);
  }

  @Watch("filtre.q")
  onAramaDegisti() {
    clearTimeout(this.aramaGecikmesi);
    this.aramaGecikmesi = setTimeout(() => this.filtreUygula(), 500);
  }

  @Watch("filtre.error_code")
  onHataKoduDegisti() {
    clearTimeout(this.aramaGecikmesi);
    this.aramaGecikmesi = setTimeout(() => this.filtreUygula(), 500);
  }

  @Watch("olayFiltre.event")
  onOlayTipiDegisti() {
    this.olayAramaGecikmesiKur();
  }

  @Watch("olayFiltre.error_code")
  onOlayHataKoduDegisti() {
    this.olayAramaGecikmesiKur();
  }

  @Watch("olayFiltre.tenant_pool_id")
  onOlaySatirDegisti() {
    this.olayAramaGecikmesiKur();
  }

  private olayAramaGecikmesiKur() {
    clearTimeout(this.olayAramaGecikmesi);
    this.olayAramaGecikmesi = setTimeout(() => this.olayFiltreUygula(), 500);
  }

  /** Sayfa 1'e dönmek zaten watcher'ı tetikler; çift istek atmamak için ayrılır. */
  filtreUygula() {
    if (this.listeSecenekleri.page !== 1) {
      this.listeSecenekleri.page = 1;
    } else {
      this.listeGetir();
    }
  }

  olayFiltreUygula() {
    if (this.olaySecenekleri.page !== 1) {
      this.olaySecenekleri.page = 1;
    } else {
      this.olaylarGetir().catch(() => undefined);
    }
  }

  durumaFiltrele(durum: TenantPoolStatus) {
    this.filtre.status = [durum];
    this.sekme = 0;
    this.filtreUygula();
  }

  /* ---------------- detay ---------------- */

  detayAc(satir: TenantPoolRow) {
    this.detayAcId(satir.id);
  }

  detayAcId(id: number) {
    this.detayId = id;
    this.detayAcik = true;
  }

  imhaSonrasi() {
    this.listeGetir();
    this.ozetGetir().catch(() => undefined);
  }

  /* ---------------- mutasyonlar ---------------- */

  async doldur() {
    this.islemCalisiyor = true;
    try {
      const yanit = await this.$http.post(this.mutasyonBase + "refill");
      // 202: iş kuyruğa alındı — "tamamlandı" DEME.
      this.$toast.info(
          (yanit.data && yanit.data.message)
              ? yanit.data.message
              : "Doldurma turu başlatıldı. Sonuç bu istekle dönmez; ilerleme üst şeritten izlenir."
      );
      this.doldurDialog = false;
      // Kuyruğun ilk izi (provisioning sayacı, olay kaydı) birkaç saniye içinde
      // düşer; normal yenileme turunu beklemeden bir kez tazele.
      clearTimeout(this.ozetGecikmeli);
      this.ozetGecikmeli = setTimeout(() => {
        this.ozetGetir().catch(() => undefined);
      }, 4000);
    } catch (e) {
      // Havuz kapalıysa uç 409 döner; sunucunun mesajı olduğu gibi gösterilir.
      this.$toast.error(this.hataMesaji(e));
    } finally {
      this.islemCalisiyor = false;
    }
  }

  bakimDialogAc() {
    this.bakimSkipPurge = false;
    this.bakimMax = "";
    this.bakimDialog = true;
  }

  async bakim() {
    this.islemCalisiyor = true;
    try {
      // `max` sunucuda YALNIZCA query string'den okunur; gövdeye konursa sessizce yok sayılır.
      const config: any = {};
      if (!this.bakimSkipPurge && this.bakimMax !== "" && this.bakimMax !== null) {
        config.params = {max: this.bakimMax};
      }
      const yanit = await this.$http.post(
          this.mutasyonBase + "cleanup",
          {skip_purge: this.bakimSkipPurge},
          config
      );

      const veri = (yanit.data && yanit.data.data) ? yanit.data.data : {};
      if (veri.skipped === "locked") {
        this.$toast.info("Bakım turu atlandı: başka bir bakım işlemi sürüyor. Birazdan tekrar deneyin.");
      } else {
        this.$toast.success(
            "Bakım turu tamamlandı — iade/karantina: " + this.sayi(veri.released_or_quarantined)
            + ", sahipsiz işaretlenen: " + this.sayi(veri.stuck_marked)
            + ", evlat edinilen: " + this.sayi(veri.adopted)
            + ", imha edilen: " + this.sayi(veri.purged)
        );
      }
      this.bakimDialog = false;
      this.tumunuYenile();
    } catch (e) {
      this.$toast.error(this.hataMesaji(e));
    } finally {
      this.islemCalisiyor = false;
    }
  }

  async devreyiKapat() {
    this.islemCalisiyor = true;
    try {
      const yanit = await this.$http.post(this.mutasyonBase + "circuit/close");
      this.$toast.success(
          (yanit.data && yanit.data.message)
              ? yanit.data.message
              : "Devre kapatıldı."
      );
      this.devreDialog = false;
      this.ozetGetir().catch(() => undefined);
    } catch (e) {
      this.$toast.error(this.hataMesaji(e));
    } finally {
      this.islemCalisiyor = false;
    }
  }

  /* ---------------- hata biçimlendirme ---------------- */

  private sayi(deger: any): number {
    return typeof deger === "number" ? deger : 0;
  }

  /** 422 gövdesindeki `errors` bir NESNEDİR (alan -> mesaj dizisi), düz dizi değil. */
  private alanHatalari(e: any): any {
    const yanit = e && e.response;
    if (!yanit || yanit.status !== 422) {
      return {};
    }
    const hatalar = yanit.data ? yanit.data.errors : null;
    if (!hatalar || typeof hatalar !== "object") {
      return {};
    }
    const sonuc: any = {};
    Object.keys(hatalar).forEach(alan => {
      const deger = hatalar[alan];
      sonuc[alan] = Array.isArray(deger) ? deger : [String(deger)];
    });
    return sonuc;
  }

  /**
   * `errors` nesnesinde ekranda karşılığı olmayan alanlar da gelebilir
   * (sort, dir, since, until — elle URL ile geçersiz değer gönderildiğinde).
   * Bunlar sessizce kaybolmasın diye üstteki hata satırına eklenir.
   */
  private eslesmeyenHatalar(hatalar: any, ekrandakiAlanlar: string[]): string {
    const parcalar: string[] = [];
    Object.keys(hatalar).forEach(alan => {
      if (ekrandakiAlanlar.indexOf(alan) === -1) {
        parcalar.push(alan + ": " + [].concat(hatalar[alan]).join(" "));
      }
    });
    return parcalar.join(" · ");
  }

  /** Sunucunun kendi mesajını olduğu gibi gösterir; kendi metnini uydurmaz. */
  private hataMesaji(e: any): string {
    const yanit = e && e.response;
    if (!yanit) {
      return "Sunucuya ulaşılamadı.";
    }
    const govde = yanit.data || {};
    if (yanit.status === 500 && govde.reference) {
      return (govde.message || "İşlem başarısız.") + " (Destek için referans: " + govde.reference + ")";
    }
    if (yanit.status === 503) {
      return govde.message || "Havuz operasyon uçları kapalı (token yapılandırılmamış).";
    }
    if (yanit.status === 403) {
      return govde.message || "Havuz operasyon yetkiniz yok.";
    }
    if (yanit.status === 429) {
      // Bu metin hem pasif yenilemede hem elle tetiklenen işlemlerde kullanılır;
      // yalnızca pasif yolda geçerli olan bir şey ("yenileme yavaşlatıldı") deme.
      return "Hız sınırına ulaşıldı; kısa bir süre bekleyip tekrar deneyin.";
    }
    return govde.message || ("İstek başarısız (HTTP " + yanit.status + ").");
  }

  /* ---------------- yaşam döngüsü ---------------- */

  mounted() {
    this.gorunurlukDinleyicisi = () => this.gorunurlukDegisti();
    document.addEventListener("visibilitychange", this.gorunurlukDinleyicisi);

    // Liste ve olaylar `options.sync` watcher'ları ile ilk turda kendiliğinden gelir.
    this.ozetYukleniyor = true;
    this.ozetGetir()
        .catch(e => this.pollHatasi(e))
        .then(() => {
          this.ozetYukleniyor = false;
          this.zamanla();
        });
  }

  beforeDestroy() {
    this.yokEdildi = true;
    this.zamanlayiciTemizle();
    clearTimeout(this.aramaGecikmesi);
    clearTimeout(this.olayAramaGecikmesi);
    clearTimeout(this.ozetGecikmeli);
    if (this.gorunurlukDinleyicisi !== null) {
      document.removeEventListener("visibilitychange", this.gorunurlukDinleyicisi);
      this.gorunurlukDinleyicisi = null;
    }
  }
}
